export default "__VITE_ASSET__CDT5Ks7m__"